import { Link, Navigate, useParams } from "react-router-dom";
import { useLessons } from "../data/LessonsContext";
import useProgress from "../data/useProgress";
import { COMPLETED } from "../data/progressStore";
import { CheckIcon } from "../components/Icons";
import {
  LoadingCards,
  NotAvailable,
  SavedLabel,
} from "../components/Status";
import ui from "../components/ui.module.css";
import { subjectPath, teachingContext } from "./Week";
import { useClassrooms } from "../data/ClassroomContext";

const LessonComplete = () => {
  const { slug } = useParams();
  const lessons = useLessons();
  const progress = useProgress();
  const classes = useClassrooms();
  const lesson = lessons.findLesson(slug);

  if (lessons.status === "loading") {
    return (
      <div className={ui.page}>
        <LoadingCards count={1} />
      </div>
    );
  }
  if (!lesson) {
    return (
      <div className={ui.page}>
        <NotAvailable />
      </div>
    );
  }
  const record = progress.get(lesson.id);
  if (record?.status !== COMPLETED) {
    return <Navigate to={`/lesson/${lesson.slug}`} replace />;
  }

  const context = teachingContext({
    className: classes.active.name,
    subject: lesson.subject,
    week: lesson.week,
  });

  return (
    <>
      <div className={`${ui.page} ${ui.centered}`}>
        <CheckIcon className={ui.bigIcon} size={64} />
        <h1 className={ui.title}>Lesson complete</h1>
        <p className={ui.cardTitle}>{lesson.title}</p>
        {context && <p className={ui.meta}>{context}</p>}
        <p className={ui.pill} role="status">
          <SavedLabel record={record} />
        </p>
      </div>
      <div className={ui.actionBar}>
        <div className={ui.actionBarInner}>
          <Link to={subjectPath(lesson.subjectKey)} className={`${ui.button} ${ui.primary}`}>
            Back to {lesson.subject || "lessons"}
          </Link>
        </div>
      </div>
    </>
  );
};

export default LessonComplete;
